import { useMutation } from '@tanstack/react-query';
import { SendCodeRequest, VerifyCodeRequest, VerifyCodeResponse } from './types';
import { sendEmailForCode, sendVerificationCode } from './api';
import { useNavigate } from 'react-router-dom';
import { CacheKeys } from 'utils/cacheKeys';
import { useBusiness } from 'providers/context/BusinessProvider';
import * as urls from 'routes/config';
import http from 'utils/http';
import { AgentResponse } from 'apis/business/agent/types';
import { setCookie } from 'utils/helperFunctions';

export function useSendEmailForCode() {
  const navigate = useNavigate();

  return useMutation({
    mutationFn: (payload: SendCodeRequest) => {
      setCookie(CacheKeys.userEmail, payload.email);
      return sendEmailForCode(payload);
    },
    onSuccess: () => {
      navigate(`${urls.auth.base}/${urls.auth.emailVerification}`);
    }
  });
}

export function useSendVerificationCode() {
  const navigate = useNavigate();
  const { setSelectedBusiness, setSelectedWorkspace } = useBusiness();

  return useMutation({
    mutationFn: (payload: VerifyCodeRequest) => sendVerificationCode(payload),
    onSuccess: async (data: VerifyCodeResponse) => {
      const workspaceId = data.meta.businesses?.[0]?.workspaces?.[0].id;
      const userStatus = data.agency_user || data.meta.businesses?.[0]?.account_status;
      setCookie(CacheKeys.authToken, data.meta.token);
      setCookie(CacheKeys.userStatus, userStatus);
      if (!userStatus) {
        navigate('/welcome');
      } else {
        if (Boolean(data.agency_user)) {
          navigate(urls.agency.base);
        } else {
          setSelectedBusiness(data.meta.businesses?.[0]?.id);
          setSelectedWorkspace(data.meta.businesses?.[0]?.workspaces?.[0].id);
          localStorage.setItem(CacheKeys.businessIds, JSON.stringify(data.meta.businesses?.map((item) => item.id)));
          localStorage.setItem(
            CacheKeys.workspaceIds,
            JSON.stringify(data.meta.businesses?.[0]?.workspaces?.map((item) => item.id))
          );
          const response = await http.get(`business/workspaces/${workspaceId}/agents`);
          if (response.data.length) {
            let ids = response.data?.map((item: AgentResponse) => item.id);
            localStorage.setItem(CacheKeys.agentIds, JSON.stringify(ids));
            navigate(
              `${urls.agentBase(
                data.meta.businesses?.[0]?.workspaces?.[0].id,
                response.data[0].id
              )}/${urls.home.performance}`
            );
          } else {
            navigate(`${urls.base(data.meta.businesses?.[0]?.workspaces?.[0].id)}/${urls.onBoarding.create}`);
          }
        }
      }
    }
  });
}
